import(/* webpackMode: "eager" */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/app/[locale]/error.tsx");
